import React from 'react';
import ReactDOM from 'react-dom';
import { loadIdPvr, loadLanguage, loadSessionToken, loadSystemCode } from './data/utils';
import { appConfig } from './InitData';
import Main from './Main';

//export const baseURL = process.env.REACT_APP_API_URL;
export const apiDomain = process.env.REACT_APP_API_DOMAIN;
export const warName = process.env.REACT_APP_WAR_NAME? process.env.REACT_APP_WAR_NAME : 'XSportDatastore';
export const systemCode = loadSystemCode(apiDomain) || ( (appConfig['SYSTEM_CODE']||null) != null ? appConfig['SYSTEM_CODE'] : '');
export let xs_sessionToken = null;
export const xs_languageCode = loadLanguage();
export const xs_idPvr = loadIdPvr();
export const xs_isMobile = false;
export const xs_product_code = 3;
export const xs_product_code_xcasino_desktop = 4;

function setSessionToken(){
	xs_sessionToken = loadSessionToken();
}

setSessionToken();


window.xsp_reloadSessionToken = function() {
	setSessionToken();
	if(window.ucReloadUser){
		window.ucReloadUser();
	}
	else{
		setTimeout(function () { window.xsp_reloadSessionToken()}, 100);
	}
}





if(typeof String.prototype.replaceAll === 'undefined'){
    console.log("replaceAll is not defined! I create it!");
    String.prototype.replaceAll = function(target, replacement) {
          return this.split(target).join(replacement);
    };
}

function renderOnlineSportbook(){
	ReactDOM.render(
        <Main />,
        document.getElementById('xsport-container')
    );
}

window.whenJqueryLoaded(function () {
    renderOnlineSportbook();
});

window.renderOnlineSportbook = renderOnlineSportbook;
